import React from 'react';
import DebounceLoader from "./DebounceLoader";
var SuspenseDebounceLoader = function SuspenseDebounceLoader() {
  return /*#__PURE__*/React.createElement(DebounceLoader, {
    loaded: false
  }, /*#__PURE__*/React.createElement("div", null));
};
export default SuspenseDebounceLoader;